import type { CategoryRadius } from "react-migration/domains/constraints/designation/hooks/useNearestDesignationQuery";

export const MAX_AMENITY_RADIUS_METERS = 5000;

/**
 * UK config
 */

export const PRIMARY_SCHOOL_CATEGORY = "primary_school";
export const SECONDARY_SCHOOL_CATEGORY = "secondary_school";
export const FURTHER_EDUCATION_CATEGORY = "further_education";

export const PRIMARY_SCHOOL_INDEPENDENT_CATEGORY = "primary_school_independent";
export const SECONDARY_SCHOOL_INDEPENDENT_CATEGORY = "secondary_school_independent";
export const FURTHER_EDUCATION_INDEPENDENT_CATEGORY = "further_education_independent";

export const TRAIN_STATION_CATEGORY = "train_station";
export const SUBWAY_STATION_CATEGORY = "metro_station";
export const BUS_STOP_CATEGORY = "bus_stop";

export const SUPERMARKETS_AND_CONVENIENCE_STORES_CATEGORY = "supermarkets_and_convenience_stores";

export const GP_SURGERIES_CATEGORY = "gp_surgeries";
export const PHARMACIES_CATEGORY = "pharmacies";
export const CLINICS_CATEGORY = "clinics";
export const DENTISTS_CATEGORY = "dentists";
export const HOSPITALS_CATEGORY = "hospitals";

export const CLOSEST_AMENITY_RADIUSES: CategoryRadius[] = [
  { category: PRIMARY_SCHOOL_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: SECONDARY_SCHOOL_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: FURTHER_EDUCATION_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },

  { category: PRIMARY_SCHOOL_INDEPENDENT_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: SECONDARY_SCHOOL_INDEPENDENT_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: FURTHER_EDUCATION_INDEPENDENT_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },

  { category: TRAIN_STATION_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: SUBWAY_STATION_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: BUS_STOP_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },

  {
    category: SUPERMARKETS_AND_CONVENIENCE_STORES_CATEGORY,
    radiusMeters: MAX_AMENITY_RADIUS_METERS,
  },

  { category: GP_SURGERIES_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: PHARMACIES_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: CLINICS_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: DENTISTS_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: HOSPITALS_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
];

/**
 * US config
 */

export const US_SCHOOLS_ELEMENTARY_CATEGORY = "us_schools_elementary";
export const US_SCHOOLS_MIDDLE_CATEGORY = "us_schools_middle";
export const US_SCHOOLS_HIGH_CATEGORY = "us_schools_high";
export const US_SCHOOLS_COMBINATION_CATEGORY = "us_schools_combination";
export const US_SCHOOLS_OTHER_CATEGORY = "us_schools_other";

export const US_SCHOOLS_PRIVATE_ELEMENTARY_CATEGORY = "us_schools_private_elementary";
export const US_SCHOOLS_PRIVATE_SECONDARY_CATEGORY = "us_schools_private_secondary";
export const US_SCHOOLS_PRIVATE_COMBINED_CATEGORY = "us_schools_private_combined";

export const CLOSEST_AMENITY_RADIUSES_US: CategoryRadius[] = [
  { category: US_SCHOOLS_ELEMENTARY_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: US_SCHOOLS_MIDDLE_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: US_SCHOOLS_HIGH_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: US_SCHOOLS_COMBINATION_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: US_SCHOOLS_OTHER_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: US_SCHOOLS_PRIVATE_ELEMENTARY_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: US_SCHOOLS_PRIVATE_SECONDARY_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
  { category: US_SCHOOLS_PRIVATE_COMBINED_CATEGORY, radiusMeters: MAX_AMENITY_RADIUS_METERS },
];
